import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full overflow-x-hidden"
}
const _hoisted_2 = { class: "grid sm:grid-cols-2 sm:gap-3 h-auto w-full px-3" }
const _hoisted_3 = {
  key: 0,
  class: "pb-0 sm:pb-24"
}
const _hoisted_4 = { class: "md:text-5xl sm:text-4xl text-3xl font-bold w-full py-10 block leading-normal" }
const _hoisted_5 = { class: "w-screen" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "",
    class: "w-auto"
  })
], -1)
const _hoisted_9 = { class: "flex flex-col w-full px-3" }
const _hoisted_10 = { class: "md:text-5xl sm:text-4xl text-3xl font-bold w-full text-center py-10 block leading-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_meta_data_tab = _resolveComponent("base-meta-data-tab")!
  const _component_base_meta_data = _resolveComponent("base-meta-data")!
  const _component_the_grid = _resolveComponent("the-grid")!

  return (_ctx.result)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.person)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("section", null, [
                  _createElementVNode("div", null, [
                    (_ctx.currentPage)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 0,
                          class: "inline⁻block w-full",
                          text: _ctx.t('creator.goBack') + ' ' + _ctx.currentPage.name,
                          "custom-style": "details-black",
                          "custom-icon": "arrowLeftLine",
                          "icon-shown": true,
                          onClick: _ctx.goToPreviousPage
                        }, null, 8, ["text", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.person.fullName), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_base_meta_data_tab, {
                    "tab-names": _ctx.tabs,
                    hidden: true
                  }, null, 8, ["tab-names"])
                ]),
                (_ctx.person.extraInfo.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.person.extraInfo, (info, index) => {
                        return (_openBlock(), _createBlock(_component_base_meta_data, {
                          key: index,
                          "key-word": _ctx.t('creator.' + info.key),
                          type: info.value,
                          "error-text": _ctx.t('details.modal.unknown'),
                          class: "w-full"
                        }, null, 8, ["key-word", "type", "error-text"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_7, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.t('creator.noMetadata')), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.t('creator.moreWorks') + ' ' + _ctx.person.fullName), 1),
          _createVNode(_component_the_grid, {
            small: true,
            "no-header": true,
            class: "sm:mt-24",
            "default-relations": ['entities/' + _ctx.id],
            "no-filters": true
          }, null, 8, ["default-relations"])
        ])
      ]))
    : _createCommentVNode("", true)
}